import type { LangCopy } from '@CS/components/TranslationProvider/types';
import { getCampaignPublicData } from '@/redux/campaign/selectors';
import { Popup, About, FADE_DURATION } from '@/components/Popups';
import { MenuContainer, MenuContent } from './Menu.styles';
import Hamburger from '@CS/assets/menu.svg?component';
import Home from '@CS/assets/home.svg?component';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import { useTranslations } from '@/hooks';
import { connect } from 'react-redux';
import { useState } from 'react';
import Content from './content';

type MenuProps = {
  campaignData: object | null;
  onOnboarding?: () => void;
  onClose?: () => void;
};

export const Menu = ({ campaignData, onOnboarding, onClose }: MenuProps) => {
  const { image /* campaign, onboarding, home, termsLink, terms */ } =
    useTranslation(Content);

  const [campaign, onboarding, home, terms] = useTranslations([
    '04MenuPopupAboutButton',
    '04MenuPopupOnboardingButton',
    '04MenuPopupHomeButton',
    '04MenuPopupTermsLink'
  ]);

  const termsLink = useTranslation(
    ((campaignData as { termsLink: LangCopy }) ?? Content).termsLink ?? Content.termsLink
  );

  const closeAbout = () =>
    setTimeout(() => ~setAbout(false) && showMenu(), FADE_DURATION) &&
    setClose(false);

  const onAbout = () =>
    setTimeout(() => ~setAbout(true) && closeMenu(), FADE_DURATION) &&
    setClose(true);

  const [about, setAbout] = useState(false);
  const [close, setClose] = useState(false);
  const [menu, setMenu] = useState(false);

  const closeMenu = () => setMenu(false);
  const showMenu = () => setMenu(true);

  const menuStyle = {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    maxWidth: '100%',
    bottom: 'unset',
    width: '100%'
  };

  return (
    <MenuContainer>
      <Button onClick={showMenu} round>
        <Hamburger />
      </Button>

      {menu && (
        <Popup close={close} customStyle={menuStyle} onClose={closeMenu}>
          <img alt="Golden Getaway" src={image} />

          <MenuContent>
            <Button onClick={onAbout}>{campaign}</Button>
            <Button
              onClick={() => {
                closeMenu();
                onOnboarding?.();
              }}
            >
              {onboarding}
            </Button>

            <Button onClick={onClose}>
              <Home />
              {home}
            </Button>

            <a href={termsLink}>{terms}</a>
          </MenuContent>
        </Popup>
      )}

      {about && <About onBeforeClose={closeAbout} />}
    </MenuContainer>
  );
};

const mapStateToProps = (state: never) => ({
  campaignData: getCampaignPublicData(state)
});

export default connect(mapStateToProps)(Menu);
